import { render, staticRenderFns } from "./Masterpage.vue?vue&type=template&id=5cb3cf36&"
import script from "./Masterpage.vue?vue&type=script&lang=js&"
export * from "./Masterpage.vue?vue&type=script&lang=js&"
import style0 from "./Masterpage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports